module.exports = __webpack_public_path__ + "assets/title-bg.3ae642ed.svg";